module.exports = __webpack_public_path__ + "media/images/project/back-2d37444e71038ffe4ad9a43bb70f9059.svg";